import NoResultsComponent from './no-results.component'

const NoResultsModule = angular.module('cdbl.no-results', [

])
  .component('cdblNoResults', NoResultsComponent)
  .name

export default NoResultsModule
